<template>
    <div>
        <div class="form-group"
             :class="{'has-error': errors.has('dateDebut') }">
            <label>{{TextDateDebut}}</label>
            <div class="input-group date">
                <div class="input-group-addon">
                    <i class="fa fa-calendar"></i>
                </div>
                <masked-input type="text"
                              v-model="dateDebut"
                              name="dateDebut"
                              v-validate="'required|date_format:DD/MM/YYYY'"
                              :mask="[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]"
                              :guide="true"
                              :keepCharPositions="true"
                              :showMask="true"
                              class="form-control pull-right datepicker"
                              id="datepicker1">
                </masked-input>
            </div>
            <span v-show="errors.has('dateDebut')"
                  class="help-block">Date incorrecte</span>
        </div>

        <div class="form-group"
             :class="{'has-error': errors.has('dateFin') }">
            <label>{{TextDateFin}}</label>
            <div class="input-group date">
                <div class="input-group-addon">
                    <i class="fa fa-calendar"></i>
                </div>
                <masked-input type="text"
                              v-model="dateFin"
                              name="dateFin"
                              v-validate="'required|date_format:DD/MM/YYYY|after:dateDebut,true'"
                              :mask="[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]"
                              :guide="true"
                              :keepCharPositions="true"
                              :showMask="true"
                              class="form-control pull-right datepicker"
                              id="datepicker2">
                </masked-input>
            </div>
            <span v-show="errors.has('dateFin')"
                  class="help-block">Date incorrecte</span>
        </div>
    </div>
</template>

<script type="text/babel">
    import Auth from '@/auth'
    import searchGeneral from '../Communs/searchGeneral'
    import {mapGetters, mapActions} from 'vuex'

    var $ = require('jquery');
    var _ = require('underscore')
    var moment = require('moment')

    export default {
        inject: ['$validator'], // inject parent validator
        props: {
            TextDateDebut: {
                type: String,
                default: function () {
                    return 'Date de début'
                }
            },
            TextDateFin: {
                type: String,
                default: function () {
                    return 'Date de fin'
                }
            },
            dateDebutPrefill: {
                type: String,
                default: function () {
                    return moment().format('DD/MM/YYYY')
                }
            },
            dateFinPrefill: {
                type: String,
                default: function () {
                    return moment().format('DD/MM/YYYY')
                }
            },
        },
        data() {
            return {
                dateDebut: null,
                dateFin: null,
            }
        },
        mounted: function () {
            this.dateDebut = this.dateDebutPrefill
            this.dateFin = this.dateFinPrefill
        },
        components: {
            searchGeneral
        },
        watch: {
            dateDebut: function () {
                this.$emit('onDateDebutChange', this.dateDebut)
            },
            dateFin: function () {
                this.$emit('onDateFinChange', this.dateFin)
            },
        },
        computed: {
            ...mapGetters({
                getMainUser: 'getMainUser',
                getRoute: 'getRoute'
            })
        },
    };
</script>


// WEBPACK FOOTER //
// src/components/Communs/DateAvantDateApres.vue